<template>
    <div class="position-relative">
        <v-dialog
            v-model="showDrawer"
            scrollable
            height="100vh"
            transition="none"
            width="45%"
            max-width="85vw"
            content-class="drawer rounded-0"
        >
            <v-card class="pa-0 rounded-0" height="100vh">
                <v-card-title class="mb-2 px-4 pt-4">
                    <v-icon
                        class="mr-2"
                        @click="showDrawer = !showDrawer">
                        mdi-chevron-right
                    </v-icon>
                    {{ getAction() }} Ponto de Venda
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="py-4">
                    <div>
                        <v-form ref="form" v-model="valid" v-if="!loading" class="pa-4">
                            <v-row>
                                <v-text-field
                                    outlined
                                    v-model="name"
                                    :rules="nameRules"
                                    label="Nome do Ponto de Venda"
                                    required>
                                </v-text-field>
                            </v-row>
                            <v-row>
                                <v-textarea
                                    outlined
                                    v-model="note"
                                    rows="2"
                                    label="Observação">
                                </v-textarea>
                            </v-row>
                            <v-row>
                                <v-col v-if="agreementImageSaved" class="text-center border" cols="12">
                                    <label>Print do Acordo:</label>
                                    <div class="thumbnail-display">
                                        <a :href="`/storage/pointsOfSale${agreementImageSaved}`" class="thumbnail">
                                            <v-img
                                                contain
                                                :src="`/storage/pointsOfSale${agreementImageSaved}`"/>
                                        </a>
                                        <v-btn class="mt-2" color="red" outlined @click="agreementImageSaved = null">
                                            Trocar Print do Acordo
                                            <v-icon>mdi-close-circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                                <v-col v-else cols="12">
                                    <label>Print do Acordo:</label>
                                    <file-input
                                        compress
                                        :compress-factor-breakpoints="[0.5, 2.5]"
                                        :maxFilesAllowed="1"
                                        v-model="agreementImage"
                                        label="Adicione aqui o print do acordo da empresa."
                                    />
                                </v-col>
                                <div v-if="!imageValid" class="v-messages theme--light error--text mt-1" role="alert">
                                    <div class="v-messages__wrapper">
                                        <div class="v-messages__message">*O print do acordo é obrigatório!</div>
                                    </div>
                                </div>
                            </v-row>
                            <v-row v-if="pointOfSale" class="justify-center">
                                <div class="mt-2">
                                    <p class="align-self-end mb-0 text-center active-label">Status</p>
                                    <v-btn-toggle
                                        v-model="active"
                                        mandatory
                                    >
                                        <v-btn :value="1" width="50%" :color="active ? 'success' : ''">Ativo</v-btn>
                                        <v-btn :value="0" width="50%" :color="!active ? 'error' : ''">Inativo</v-btn>
                                    </v-btn-toggle>
                                </div>
                            </v-row>
                            <p v-if="!active" class="mt-2 inactive-warning">
                                *Ao desativar, nenhuma tarifa relacionada com este ponto de venda será mostrada aos clientes!
                            </p>
                        </v-form>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-btn class="w-50" text @click="showDrawer = !showDrawer">
                        Cancelar
                    </v-btn>
                    <v-btn class="w-50" color="success" w-50 @click="validate">
                        {{ getAction() }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <response-modal
            :show-dialog="responseDialog"
            :message="responseMessage"
            :type="responseType"
            @close="closeAndReloadPage"
        />
    </div>
</template>

<script>
import FileInput from "../FileInput";
import ResponseModal from "../Modals/ResponseModal";

export default {
    name: "PointOfSaleFormDrawer",

    components: {
        FileInput,
        ResponseModal,
    },

    props: {
        drawer: {
            type: Boolean,
            default: false,
        },
        pointOfSale: {
            type: Object,
        }
    },

    data: () => ({
        showDrawer: false,
        name: '',
        note: '',
        agreementImage: null,
        active: '',
        loading: false,
        responseDialog: false,
        responseMessage: '',
        responseType: '',
        imageValid: false,
        agreementImageSaved: null,
        nameRules: [
            v => !!v || 'O campo Nome do Ponto de Venda é obrigatório'
        ],
        valid: '',
        hasValidated: false,
    }),

    methods: {
        async getData() {
            return {
                "name": this.name,
                "note": this.note,
                "active": this.active,
                "agreementImage": this.agreementImageSaved ? null : this.agreementImage ? await this.toBase64(this.agreementImage[0]) : null
            }
        },

        setData(pointOfSale) {
            this.name = pointOfSale.name;
            this.note = pointOfSale.note;
            this.active = pointOfSale.active;
            this.agreementImageSaved = pointOfSale.agreement_image;
        },

        clearData() {
            this.name = '';
            this.note = '';
            this.agreementImage = null;
            this.agreementImageSaved = null;
            this.active = true;
            this.loading = false;
        },

        validate() {
            this.hasValidated = true;
            this.$refs.form.validate();
            if (this.imageIsValid()) {
                this.saveSalePoint();
            }
        },

        getAction() {
            if (this.pointOfSale) {
                return 'Atualizar';
            }
            return 'Cadastrar';
        },

        imageIsValid() {
            if (this.valid) {
                if (this.agreementImageSaved !== null || (this.agreementImage !== null && this.agreementImage.length !== 0)) {
                    return true;
                }
            }
            return false;
        },

        getStatus() {
            if (this.active == true) {
                return 'Ativo';
            }
            return 'Inativo';
        },

        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),

        async saveSalePoint() {
            let data = {};
            Object.assign(data, await this.getData());
            if (!this.pointOfSale) {
                data.active = true;
                axios.post('/api/point-of-sale', data)
                    .then(res => {
                        this.getResponseData(res.data.success, 'criar')
                    }).catch(() => {
                        this.getResponseData(false, 'criar');
                    }).finally(() => {
                        this.responseDialog = true;
                    });
            }
            if (this.pointOfSale) {
                axios.put(`/api/point-of-sale/${this.pointOfSale.id}`, data)
                    .then(res => {
                        this.getResponseData(res.data.success, 'atualizar')
                    }).catch(() => {
                        this.getResponseData(false, 'atualizar');
                    }).finally(() => {
                        this.responseDialog = true;
                    });
            }
        },

        getResponseData(success, action) {
            this.responseMessage = '';
            this.responseType = '';
            if (success === true) {
                this.responseMessage = 'Sucesso ao ' + action + ' o ponto de venda!';
                this.responseType = 'success';
            } else {
                this.responseMessage = 'Falha ao tentar ' + action + ' o ponto de venda!';
                this.responseType = 'error';
            }
        },

        closeAndReloadPage() {
            this.responseDialog = false;
            this.showDrawer = !this.showDrawer;
            window.location.reload();
            this.$forceUpdate();
        },
    },

    watch: {
        drawer: function() {
            this.showDrawer = !this.showDrawer;
            if (!this.pointOfSale) {
                this.clearData()
            }

            if (this.pointOfSale) {
                this.setData(this.pointOfSale);
            }
        },
        agreementImage: function(val) {
            this.imageValid = val !== null && val.length !== 0;
        },
        agreementImageSaved: function(val) {
            this.imageValid = val != null;
        },
    }
}
</script>

<style scoped>
>>> .drawer {
    max-height: 100vh;
    height: 100vh;
    margin: 0;
    transition: transform 0.5s;
}

>>> .none-enter-to {
    transform: translateX(0px);
}

>>> .none-enter-active {
    transform: translateX(100%);
}

>>> .none-leave-active {
    transform: translateX(100%);
}

.v-dialog__content {
    justify-content: flex-end;
    border-radius: 0;
}

.inactive-warning {
    font-size: 12px;
    color: #f44336;
}
</style>
